import { ValidationRule, helpers } from 'vuelidate/lib/validators';
import { isValidIBAN } from 'ibantools';

export const iban = ((value: string): boolean => {
    return !helpers.req(value) || isValidIBAN(value);
}) as ValidationRule;
